/**
 * ChangePasswordCtrl controller
 */

/**
 * ChangePasswordCtrl controller
 *
 * @class ChangePasswordCtrl
 * @memberof mwApp/auth
 * @see mwApp/auth
 *
 * @ngdoc controller
 * @name mwApp/auth.controller:ChangePasswordCtrl
 */
/* @ngInject */
export default function ChangePasswordCtrl ($scope, $uibModalInstance, authSvc, alertSvc) {
  var vm = this

  /**
   * Object with passwords
   *
   * @memberof mwApp/auth.controller:ChangePasswordCtrl
   * @type {Object}
   */
  vm.pwd = {
    oldPwd: null,
    newPwd: null
  }

  /**
   * Error message from server
   *
   * @type {String}
   */
  vm.error = null

  // reset incorrect current password flag
  $scope.$watch('vm.pwd.oldPwd', () => {
    $scope.form.password.$setValidity("incorrect", true)
  })

  /**
   * Perform request to restore user's password
   *
   * @memberof mwApp/auth.controller:ChangePasswordCtrl
   */
  vm.changePassword = function () {
    authSvc.changePassword(vm.pwd)
      .then(
        response => {
          vm.error = null
          alertSvc.alert(response.data, 'success')
          $uibModalInstance.close()
        }
      )
      .catch(
        response => {
          if (response.status === 404) {
            vm.error = 'Error: User has been blocked'
            alertSvc.alert('User has been blocked', 'danger')
          } else
          if (response.data === 'Bad password') {
            $scope.form.password.$setValidity("incorrect", false)
          } else {
            vm.error = 'Error: ' + response.data
            alertSvc.alert(response.data, 'danger')
          }
        }
      )
  }

  vm.loadImage = function(img) {
    return require('../../img/' + window.ENV.APP_PROVIDER + '/' + window.ENV.APP_PROVIDER + img)
  }

  /**
   * Close modal window
   *
   * @memberof mwApp/auth.controller:ChangePasswordCtrl
   */
  vm.close = function () {
    $uibModalInstance.dismiss('cancel')
  }
}
